import ImportInstructionsModal from './ImportInstructionsModal';

export default ImportInstructionsModal;
